export const assets = {
  AssetPerformanceReport: {
    mandatory: [],
    default: [
      'AccountName',
      'AccountId',
      'CampaignName',
      'CampaignId',
      'AssetId',
      'AssetContent',
      'AssetType',
      'AssetSource',
      'Impressions',
      'Clicks',
      'CTR',
      'Spend',
      'VideoViews',
      'VideoViewsAt25Percent',
      'VideoViewsAt50Percent',
      'VideoViewsAt75Percent',
      'VideoCompletionRate',
      'CompletedVideoViews',
    ],
  },
};

